module.exports = MaterialUI.Select;